import React, { Fragment } from "react";
import { NavigationTarget, WebchatOptions } from "../../Redux/reduxState";
import { CustomizationEntry } from "../customizeEntries";
import { CustomizationEntrySelector } from "./customizationEntrySelector";
import { CustomizationEntrySubCategory } from "./customizationEntrySubCategory";
import { mergeStyles } from "@fluentui/react";
import { ContainerName } from "../../Redux/reducers/AppReducer";
import { OptionValueGetter } from "./optionValue";

const entryViewerContainer = mergeStyles(
    {
        display: 'block',
        paddingTop: '25px',
        paddingBottom: '25px',
        '> div:last-of-type': {
            borderBottom: '1px solid var(--druid-color-border) !important',
        },
    }
);

const defaultEntriesContainer = mergeStyles(
    {
        marginBottom: '10px',
    }
);

interface Props {
    category: string;
    entries: CustomizationEntry[];
    webchatOptions: WebchatOptions;
    navigationTarget?: NavigationTarget;
    updateStyleElement: (styleElementName: string, value: any, containerName?: ContainerName) => void;
    getStyleOptionValue: OptionValueGetter;
}

const groupBySubCategory = (entries: CustomizationEntry[]) => {
    const subCategories = new Map<string, CustomizationEntry[]>();
    entries.forEach(entry => {
        const subCategory = entry.subCategory || '';
        subCategories.set(subCategory, [...(subCategories.get(subCategory) || []), entry]);
    });
    return Array.from(subCategories.entries());
};

export const ConfigurationEntryViewer = (props: Props) => {
    const { category, entries, webchatOptions, navigationTarget, updateStyleElement, getStyleOptionValue } = props;
    const subCategories = groupBySubCategory(entries);

    const renderEntry = (entry: CustomizationEntry) => (
        <CustomizationEntrySelector
            key={entry.id}
            entry={entry}
            value={getStyleOptionValue(entry.id, entry.containerName)}
            onChange={updateStyleElement}
            getStyleOptionValue={(key, containerName) => getStyleOptionValue(key, containerName || entry.containerName)}
            highlighted={navigationTarget?.entryId === entry.id}
        />
    );

    return (
        <Fragment>
            <h5>{category}</h5>
            <div className={entryViewerContainer}>
                {subCategories.map(([subCategory, subCategoryEntries]) => subCategory
                        ? <CustomizationEntrySubCategory
                            key={`${category}/${subCategory}`}
                            entries={subCategoryEntries}
                            subCategory={subCategory}
                            webchatOptions={webchatOptions}
                            updateStyleElement={updateStyleElement}
                            getStyleOptionValue={getStyleOptionValue}
                            revealRequested={navigationTarget?.subCategory === subCategory}
                            revealEntryId={navigationTarget?.entryId}
                            highlightEntryId={navigationTarget?.entryId}
                        />
                        : <div key={`${category}/`} className={defaultEntriesContainer}>{subCategoryEntries.map(renderEntry)}</div>
                    )}
            </div>
        </Fragment>
    );
};

export default ConfigurationEntryViewer;
